
import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalFullScreen from '@/components/modal/ModalFullScreen.vue';
import UiButton from '@/components/button/ui-button.vue';

import { Company, User } from '@/generated/graphql';
import InfoIcon from '@/components/icons/CancelInfoIcon.vue';

@Component({
	components: {
		ModalFullScreen,
		UiButton,
		InfoIcon,
	},
})
export default class UpgradeSubcription extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Boolean, required: true }) readonly isLoading: boolean;
	@Prop({ type: Object, required: true }) readonly subcription: any;
	@Prop({ type: String }) readonly upgradingSubcription: any;
	@Prop({ type: Array }) readonly allSubscriptionPlans: any;

	get activeSubscriptionPlan() {
		return this.allSubscriptionPlans?.find(
			(item) => item.id == this.subcription.subscription_plan_id
		);
	}
	get upgradingSubscriptionPlan() {
		return this.allSubscriptionPlans?.find(
			(item) => item.id == this.upgradingSubcription
		);
	}
}
